import { LaneActionTypes, AddLanes, ModifyLanes, DeleteLanes } from 'Actions/ActionTypes/index';
import { Lane, Id } from 'NSwag/ServerClient/Client.nswag';


/**
 * Defines methods that create action objects for Lanes in the store
 */

export const addLanes = (lanes: Lane[]): AddLanes => ({
    type: LaneActionTypes.AddLanes as LaneActionTypes.AddLanes,
    lanes
});

export const modifyLanes = (lanes: Lane[]): ModifyLanes => ({
    type: LaneActionTypes.ModifyLanes as LaneActionTypes.ModifyLanes,
    lanes
});

export const deleteLanes = (ids: Id[]): DeleteLanes => ({
    type: LaneActionTypes.DeleteLanes as LaneActionTypes.DeleteLanes,
    ids
});

export type LanesAction = ReturnType<typeof addLanes | typeof modifyLanes | typeof deleteLanes>